import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import links from '../links';
import menus from '../menus2';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false
        };
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu() {
        this.setState({ menu: !this.state.menu })
    }

    render() {
        const show = (this.state.menu) ? "show" : "";
        return (
            <header className="main-header">
                <div className="site-navigation main_menu" id="mainmenu-area">
                    <nav className="navbar navbar-expand-lg">
                        <div className="container">
                            <Link to="/" className="navbar-brand">
                                <img src="assets/images/logo92.png" alt="Expert Edge" className="img-fluid" />
                            </Link>
                            <button onClick={this.toggleMenu} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="fa fa-bars"></span>
                            </button>

                            <div className={"collapse navbar-collapse " + show}>
                                <ul className="navbar-nav me-auto">
                                    <li className="nav-item " onClick={this.toggleMenu}><HashLink to={"#"} key={"home02"} className="nav-link js-scroll-trigger">{"Home"}</HashLink></li>
                                    {
                                        menus.map((menu, i) => (
                                            <li className="nav-item " onClick={this.toggleMenu}><HashLink to={menu.tomenu} key={i} className="nav-link js-scroll-trigger">{menu.namemenu}</HashLink></li>
                                        ))
                                    }

                                </ul>
                            </div>

                            <div className="header-right-info d-none d-lg-block">
                                <Link to="/payment" className="btn btn-dark-bg btn-small"><i className="fa fa-shopping-cart me-2"></i>Get it Now For ₹ 99</Link>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        );
    }
}

export default Header;
